<template>
    <div class="modal-recharge">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">查询老人</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <el-form :model="searchForm" inline ref="searchForm">
                        <div>
                            <el-col :span="24">
                                <el-form-item prop="name">
                                    <el-input  placeholder="请输入姓名" v-model="searchForm.name" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>

                                <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                            </el-col>
                        </div>
                    </el-form>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table :data="elderlyInfo" style="width: 100%" border :height="th">

                            <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                            <el-table-column label="手机号" prop="phone"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard" width="180"></el-table-column>

                          <el-table-column prop="elderlyFund.balance" width="100" label="预交金"></el-table-column>
                            <el-table-column prop="elderlyFund.advance" width="100" label="预交金"></el-table-column>
                            <el-table-column prop="elderlyFund.imprest" width="100" label="备用金"></el-table-column>

                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleRecharge(scope.row)">退款</el-button>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-col>
                </el-row>

                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）
                    </div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>

            </div>
        </div>
        <el-dialog title='老人退款' :visible.sync="rechargeDialog" :modal-append-to-body='false' @close='closeRechargeForm' class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
            <el-form :model="rechargeForm" :rules="rules" ref="rechargeForm">
                <div>
                    <el-row>
                        <el-col :span="24" class="item">
                            <el-form-item label="退款金额" required prop="returnBalance">
                                <el-input v-model="rechargeForm.returnBalance" type="number" placeholder="请输入退款金额"></el-input>
                            </el-form-item>
                          <div v-if="elderlyRow">{{elderlyRow.elderlyFund.balance}}+{{elderlyRow.elderlyFund.advance}}+{{elderlyRow.elderlyFund.imprest}}={{elderlyRow.elderlyFund.balance+elderlyRow.elderlyFund.advance+elderlyRow.elderlyFund.imprest}}</div>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rechargeDialog=false">取 消</el-button>
                <el-button type="primary"  @click="confirm('rechargeForm')">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog title='退款验证' :visible.sync="verificationDialog" :modal-append-to-body='false' @close='closeVerifiyForm' class="dialog" width='600px' center top='30vh' :close-on-click-modal='false'>
            <el-form :model="verifiyForm" ref="verifiyForm" :rules="verifiyRules">
                <el-row v-if="elderlyRow">
                    <el-col :span="12" class="item">
                        <el-form-item label="老人姓名">
                            <el-input v-model="elderlyRow.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="退款余额">
                            <el-input v-model="elderlyRow.elderlyFund.balance" type="number" disabled placeholder="请输入退款金额"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="退款预交金">
                            <el-input v-model="elderlyRow.elderlyFund.advance" type="number" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="退款备用金">
                            <el-input v-model="elderlyRow.elderlyFund.imprest" type="number" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12" class="item">
                        <el-form-item label="验证金额" required prop="verifiyBalance">
                            <el-input v-model="verifiyForm.verifiyBalance" type="number" placeholder="请输入验证金额"></el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" >
                <el-button @click="verificationDialog=false">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="addSubmit">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog title='退款凭证' :visible.sync="voucherDialog" :modal-append-to-body='false' class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
            <div id="printTest" >
                <div class="text">
                    <p>老人姓名：{{successInfo.elderlyName}}</p>
                    <p>退款金额：{{successInfo.returnBalance}}</p>
                    <p>日期：{{formatterTime(successInfo.createTime)}}</p>
                </div>
                <div style="margin-top:30px">
                    <p>1、请当面核对票款金额，如有疑问请及时查询</p>
                    <p>2、请妥善保管此收据，查询时需校验此单</p>
                    <p>1、此系临时凭据，不做报销凭证</p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer" >
                <el-button  type="info" v-print="'#printTest'">打印</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                multipleSelection:'',
                checked:false,
                loading: false,
                elderlyInfo:[],
                elderlyRow:null,
                verificationDialog:false,
                statusValue:['全部状态','正常','禁用'],
                totalItems:0,
                voucherDialog:false,
                verifiyForm:{
                    verifiyBalance:'',
                },

                searchForm:{
                    name:'',
                    phone:'',
                    checkinStatus:1,
                    pageSize:20,
                    pageIndex:1,
                },

                rechargeForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                  returnBalance:'',
                },

                rechargeDialog:false,
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight-20,
                successInfo:'',
                rules:{
                  returnBalance:[
                        { required: true, message: '请输入退款金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ]
                },
                verifiyRules:{
                    verifiyBalance:[
                        { required: true, message: '请输入退款金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ]
                },
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val-20
            },
        },
        components:{
        },
        methods: {
            init(){
                this.$refs.searchForm.resetFields()
                this.getElderly()
            },
            formatterTime(cellValue) {
                return timefilters(cellValue)
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            getList(){
                this.$emit("getList");
                this.getElderly();
            },
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            handleRecharge(row) {
                this.elderlyRow=row
                this.rechargeForm.elderlyCode = row.elderlyCode;

              if(row.elderlyFund.balance<=0 && row.elderlyFund.advance<=0 && row.elderlyFund.imprest<=0){
                this.$message.error('此老人账号有费用未结清或无余额可退！')
                return;
              }
                this.rechargeDialog=true
            },
            closeRechargeForm(){
                this.$refs.rechargeForm.resetFields();
            },
            closeVerifiyForm(){
                this.loading=false
                this.$refs.verifiyForm.resetFields();
            },

            confirm(rechargeForm){
                this.$refs[rechargeForm].validate((valid) => {
                    if(valid){
                        this.verificationDialog=true
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.rechargeForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"RefundRecord/Add",
                    data: this.rechargeForm
                }).then(
                    (response) => {
                        this.rechargeForm.rechargeType-=1
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.rechargeDialog=false
                            this.verificationDialog=false
                            this.voucherDialog=true
                            this.successInfo=response.data.data
                            this.$emit('getList')
                            //this.getElderly()

                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

            allStatus(row,status){
                for(var i in status){
                    if(status[i].value==row){
                        return status[i].label
                    }
                }
                return "其它";
            },

            getElderly(){

                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/InsPageCheckin",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.pageInfo.list;
                            this.totalItems = response.data.data.pageInfo.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },



        }
    }


</script>





<style lang="scss" scoped>

    .modal-recharge {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;
        .dialog /deep/ .is-disabled .el-input__inner {
            background-color: #F5F7FA;
            border-color: #E4E7ED;
            color: #000;
            cursor: not-allowed;
        }
        .text{
            font-size: 16px;
            line-height: 25px;
        }
        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }

            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-form-item{
                margin: 0 5px 0 0;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
